import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../Utils/Cards/card-component.js";
import CodeSnippet from "../../Utils/CodeSnippet/code-snippet-component.js";
import DropDown from "../../Utils/DropDown/drop-down-component.js";
import Navbar from "../../Utils/Navbar/navbar-component.js";
import { Modal } from "../../Utils/Modal/modal-component.js";
import { LoadingAnimation } from "../../Utils/Progress/progress-component.js";
import { ServerEndpoint } from "../../Redux/endpoints.ts";
import { post } from "../../Services/ApiService.js";
import { useNavigate } from "react-router";
import * as AuthActions from '../../Redux/Auth/AuthActions';
import ImageUpload from "../../Utils/Upload/image-upload-component.js";

function Editor() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const freeText = useRef(null);
    const loading = useSelector((state) => state.loading);
    const user = useSelector((state) => state.auth.user);
    const [gptAuthorized, setGptAuthorized] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const userName = localStorage.getItem('name') || user.email;



    // useEffect(() => {
    //     const userSubscription = user?.subscription_id;
    //     setGptAuthorized(userSubscription !== null && userSubscription !== 1);
    // }, [user]);


    const handleImageUpload = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        // reader.onload = (e) => {
        //     dispatch(AuthActions.updateUserImage({ file: e.target.result }));
        // };
    };

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    if (loading.visible) {
        return <Modal>
            <LoadingAnimation loadingMessage={loading.message} />
        </Modal>
    }


    return (

        <div >
            {!gptAuthorized &&
                <Modal>
                    <div className="flex flex-col lg:w-full h-1/2 lg:h-1/3 w-5/6 justify-between max-w-2xl p-6 bg-white border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 transition-all duration-200">
                        <div className="flex justify-end w-full" >
                            {/* <button onClick={(e) => { e.preventDefault(); }}>x</button> */}
                        </div>

                        <div className="text-lg text-gray-600 dark:text-gray-400 my-2">
                            You are currently using the Free Tier plan. To access reciplo-AI beta, please upgrade to a plan that provides AI services.
                        </div>
                        <div className="flex justify-center flex-col mb-2">
                            <button
                                onClick={(e) => { e.preventDefault(); navigate('/home') }}
                                className="button-component px-5 my-4" >upgrade plan</button>
                            <button
                                onClick={(e) => { e.preventDefault(); navigate('/') }}
                                className="w-full inline-flex justify-center text-sm items-center py-2 font-medium text-center text-gray-900 rounded-lg border border-gray-300 hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800">
                                <svg className=" mr-2 -ml-1 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 25" strokeWidth="1.5" stroke="currentColor" ><path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" /></svg>
                                Go Back
                            </button>
                        </div>
                    </div>
                </Modal>
            }
            <div className="h-full w-full flex flex-row">
                <div className="min-h-full w-full">
                    <Navbar />
                    <main className="flex justify-center">
                        <div className="flex flex-col justify-center align-middle items-center lg:w-1/2">
                            <h3 className="text-4xl font-semibold leading-normal mb-2 text-blueGray-700">{"Which one looks best?"}</h3>
                            <h4 className="text-xl font-semibold leading-normal mb-2 text-blueGray-700">{user.email}</h4>
                            <div className="w-full px-4 lg:order-2 flex justify-center ">
                                <div className="flex w-full justify-center">
                                    <div className="flex shadow-xl w-full rounded-full align-middle border-none mt-2">
                                        {user.image ?
                                            (
                                                <img
                                                    alt="..."
                                                    src={user.image}
                                                    style={{ objectFit: 'cover' }}
                                                    className={`${imageLoaded ? 'opacity-100' : 'opacity-0'} flex shadow-xl aspect-[1] rounded-full align-middle border-none h-64 w-64 transition-all duration-150 `}
                                                    onLoad={handleImageLoad}
                                                />
                                            ) :
                                            <ImageUpload onChange={handleImageUpload} />
                                        }
                                    </div>

                                </div>
                            </div>
                            <div className="w-full px-4 lg:order-3 lg:text-right lg:self-center">
                                <div className="py-10 px-3">
                                    <button
                                        className="button-component"
                                        type="button">
                                        Edit - comming soon
                                    </button>
                                </div>
                            </div>
                            <div className="w-full lg:w-4/12 px-4 lg:order-1">
                                <div className="flex justify-center py-4 lg:pt-4 pt-8">
                                    <div className="mr-4 p-3 text-center">
                                                <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">22</span>
                                                <span className="text-sm text-blueGray-400">Friends</span>
                                            </div>
                                    <div className="p-3 text-center">
                                        <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">{33}</span>
                                        <span className="text-sm text-blueGray-400">Votes</span>
                                    </div>
                                    <div className=" p-3 text-center">
                                        <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">{44}</span>
                                        <span className="text-sm text-blueGray-400">Votes</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div >
        </div >

    );
}

export default Editor;